import * as React from 'react';
import IMPComponent from '../interfaces/IMPComponent';

import './styles.scss';
import styled from 'styled-components';

interface IEditorAreaProps extends IMPComponent, React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  placeholder?: string;
  textAreaRef: React.RefObject<HTMLTextAreaElement>;
}

const EditorContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: auto;
  overflow: auto;
  flex-grow: 1;
  margin: 0 auto;
  box-sizing: border-box;
`;

const TextArea = styled.textarea`
  border: none;
  color: ${p => p.theme.color.black};
  flex-grow: 1;
  font-family: ${p => p.theme.font.secondary};
  font-size: ${p => p.theme.font.size.large};
  line-height: 1.67;
  resize: vertical;
  padding: 67px 25% 300px;
  margin-bottom: 70px;

  &:focus {
    outline: none;
  }
`;

class EditorArea extends React.Component<IEditorAreaProps> {
  public render() {
    return (
      <EditorContainer>
        <TextArea
          heap-ignore={true}
          data-private={true}
          value={this.props.value}
          spellCheck={false}
          {...this.props}
          ref={this.props.textAreaRef}
          onKeyDown={this.onKeyDown}
        />
      </EditorContainer>
    );
  }

  private onKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      const value = this.props.textAreaRef.current!.value;
      const selectionStart = this.props.textAreaRef.current!.selectionStart;
      const selectionEnd = this.props.textAreaRef.current!.selectionEnd;
      this.props.textAreaRef.current!.value = value.substring(0, selectionStart) + '  ' + value.substring(selectionEnd);
      this.props.textAreaRef.current!.selectionStart = selectionEnd + 2 - (selectionEnd - selectionStart);
      this.props.textAreaRef.current!.selectionEnd = selectionEnd + 2 - (selectionEnd - selectionStart);
      return false;
    }

    return true;
  };
}

export default EditorArea;



// WEBPACK FOOTER //
// ./src/components/EditorArea/index.tsx